export default __webpack_public_path__ + "static/media/fog-background.c9e76193.jpg";